(function () {
	'use strict';

	angular.module('app.core')
		.directive('totalInventoryChart', totalInventoryChart);

	function totalInventoryChart($window, $filter, $timeout, $translate,
			currencyFormatService, weeklyDiffService) {
		return {
			restrict: 'A',
			scope: {},
			link: function (scope, elem, attrs) {
				var scopeAccessor = scope.$parent.$parent;

				var chart;
				var chartListener;
				var numAxisTicks = 3;

				var w = angular.element($window);
				scope.height = window.innerHeight;
				scope.paddingTop = 4;
				scope.paddingBottom = 0;
				// give element unique id
				elem[0].id = elem[0].id + scope.$id;
				var chartHeight = 250;
				if (scope.chartHeight) {
					chartHeight = scope.chartHeight;
				}

				var slideshow = false;
				if (jQuery(elem[0]).parents('.slideshowWidget').length) {
					slideshow = true;
					scope.paddingTop = 8;
					numAxisTicks = 5;
					scope.paddingBottom = 12;
				}
				setPadding();

				scope.$watch(getWindowDimensions2, function (newValue, oldValue) {
					scope.windowWidth2 = newValue.w;
					scope.height = newValue.h;
					var currentPaddingLeft = scope.paddingLeft;

					setPadding();

					if (currentPaddingLeft !== scope.paddingLeft || newValue.h !== oldValue.h || slideshow) {
						$timeout(generateChart);
					}
				}, true);

				w.bind('resize', function () {
					scope.$apply();
				});

				function getWindowDimensions2() {
					return {
						'w': Math.max(w.width(), window.innerWidth),
						'h': window.innerHeight
					};
				}

				function setPadding() {
					if (slideshow) {
						chartHeight = scope.height - 130 - 65;
						scope.paddingLeft = 75;
						scope.paddingRight = 22;
					} else if (scope.windowWidth2 >= 992) {
						scope.paddingLeft = 59;
						scope.paddingRight = 15;
						scope.axisLabelWidth = 50;
					} else if (scope.windowWidth2 >= 768) {
						scope.paddingLeft = 48;
						scope.paddingRight = 12;
						scope.axisLabelWidth = 50;
					} else {
						scope.paddingLeft = 36;
						scope.paddingRight = 12;
						scope.axisLabelWidth = 30;
					}
				}

				function getTotal(groups, rawData) {
					var total = 0;
					angular.forEach(groups, function (group) {
						if (rawData[group]) {
							total += rawData[group];
						}
					});
					return total;
				}

				function generateChart() {
					var i;
					var groups = ['totalOnHandValue', 'wipValue', 'finishedGoodValueManufactured'];
					var names = {
						'totalOnHandValue': $translate.instant('Purchased'),
						'wipValue': 'Semi-Finished',
						'finishedGoodValueManufactured': $translate.instant('Finished Goods')
					};
					var data = scopeAccessor.chartData ? scopeAccessor.chartData : [];
					if (!data.length) {
						return;
					}
					var currency = scopeAccessor.currency;
					var dateList = [];
					angular.forEach(data, function (dp) {
						dateList.push($filter('date')(dp.date, 'MMM dd', 'UTC'));
					});
					var startTimestamp = (data && data.length) ? data[0].date : 0;
					var endTimestamp = (data && data.length) ? data[data.length - 1].date : 0;
					// one day
					var interval = 7 * 60 * 60 * 24 * 1000;
					var possiblePoints = Math.ceil((endTimestamp - startTimestamp) / interval) + 1;
					var max = 0;
					if (data && data.length) {
						max = getTotal(groups, data[0]);
						for (var i = 0; i < data.length; i++) {
							var total = getTotal(groups, data[i]);
							if (total > max) {
								max = total;
							}
						}
					}
					var multiple = numAxisTicks - 1;
					// get a max value with a ~5% buffer that cleanly divides by number of ticks
					var yMax = Math.ceil(max * 1.05 / multiple) * multiple;
					var formattedMaxValue = currencyFormatService.get(yMax, currency);
					var config = {};

					if (formattedMaxValue && formattedMaxValue.length >= 5) {
						scope.paddingLeft += (formattedMaxValue.length - 4) * 3;
					}
					if (currency) {
						scope.paddingLeft += (5 * (currency.length - 1));
					}
					var chartWidth = jQuery('#' + elem[0].id).width() - scope.paddingLeft - scope.paddingRight;
					var barWidth = chartWidth / possiblePoints;
					
					// tell c3 where to put the chart
					config.bindto = '#' + elem[0].id;
					config.size = {
						height: chartHeight
					};
					config.padding = {
						right: scope.paddingRight,
						left: scope.paddingLeft,
						top: scope.paddingTop
					};

					config.bar = {
						width: barWidth * 0.5
					};

					config.data = {
						json: data,
						type: 'bar',
						keys: {
							value: groups
						},
						groups: [groups],
						order: null,
						names: names,
						color: function (color, d) {
							var colorCode = color;
							if (d === 'totalOnHandValue' || d.id === 'totalOnHandValue') {
								colorCode = '#9675E2';
							} else if (d === 'wipValue' || d.id === 'wipValue') {
								colorCode = '#79C3FC';
							} else if (d === 'finishedGoodValueManufactured' || d.id === 'finishedGoodValueManufactured') {
								colorCode = '#005DA7';
							}
							return colorCode;
						}
					};

					config.grid = {
						x: {
							show: false
						},
						y: {
							show: true
						}
					};

					config.legend = {
						show: true,
						item: {
							onclick: function (id) {
								chart.toggle(id);
								// update bgnum and delta
								var visibleValue = 0.0;
								var i;

								var lastPoint = scopeAccessor.chartData[scopeAccessor.chartData.length - 1];
								var visibleData = chart.data.shown();
								for (i = 0; i < visibleData.length; i++) {
									visibleValue += lastPoint[visibleData[i].id];
								}
								$timeout(function () {
									scopeAccessor.formattedBgNum = currencyFormatService.getWithParameters(
										visibleValue, 0, scopeAccessor.currency);
								});

								scopeAccessor.deltaValue = 0;
								scopeAccessor.formattedDelta = null;
								scopeAccessor.additionalDeltaText = null;
								if (scopeAccessor.chartData.length > 1) {
									var diff = weeklyDiffService.getDataPoints(scopeAccessor.chartData);

									var previousValue = 0.0;
									for (i = 0; i < visibleData.length; i++) {
										previousValue += diff.previousDataPoint[visibleData[i].id];
									}
									scopeAccessor.deltaValue = visibleValue - previousValue;
									$timeout(function () {
										scopeAccessor.status = (scopeAccessor.deltaValue > 0) ? 'bad' : 'good';
										scopeAccessor.formattedDelta = currencyFormatService.getWithParameters(
											scopeAccessor.deltaValue, 0, scopeAccessor.currency);
										scopeAccessor.additionalDeltaText = weeklyDiffService.getAdditionalLabelText(diff.previousDataPoint);
									});
								}
							}
						}
					};

					config.axis = {
						rotated: false,
						x: {
							type: 'category',
							categories: dateList,
							tick: {
								count: 5,
								outer: false,
								multiline: false
							}
						},
						y: {
							tick: {
								format: function (x) {
									return currencyFormatService.get(x, currency);
								},
								count: numAxisTicks
							},
							min: 0,
							max: yMax,
							padding: {
								bottom: 0,
								top: 0
							}
						}
					};
					chart = c3.generate(config);
				}

				scope.$watch(function () {
					return jQuery('.total-inventory-chart .c3-legend-item-tile').last().attr('x1');
				});

				chartListener = scope.$on('event:totalInventoryCtrl:getChart', function () {
					generateChart();
				});

				scope.$on('$destroy', function () {
					if (chart) {
						chart.destroy();
					}
					if (chartListener) {
						chartListener();
					}
				});
			}
		};
	}
})();
